import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import { submitSaga } from '../sagas/submitSaga';
import { confirmSaga } from '../sagas/confirmSaga';
import { initSaga } from '../sagas/initSaga';
import { getBankSaga } from '../sagas/getBankSaga';

export function* simplifiedDeductionsSaga() {
  yield takeEvery(actionTypes.INITIALIZE, initSaga);
  yield takeEvery(actionTypes.GETBANK, getBankSaga);
  yield takeEvery(actionTypes.SUBMIT, submitSaga);
  yield takeEvery(actionTypes.CONFIRM, confirmSaga);
}
